'use client';

import Link from 'next/link';

import Button from '@/components/ui/Button/Button';
import GlowDivider from '@/components/ui/GlowDivider';

import Chart from './Chart';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  const scrollToPricing = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className='bg-background relative flex min-h-[85vh] flex-col overflow-hidden md:min-h-[90vh]'>
      <div className='mx-auto flex w-full max-w-7xl flex-1 flex-col items-center justify-center gap-12 px-6 py-12 md:flex-row md:justify-between md:gap-8 md:py-20 lg:px-8'>
        {/* Left Content */}
        <div className='w-full space-y-8 md:w-[48%] lg:w-[45%]'>
          <div>
            <p className='text-secondary mb-4 text-[10px] font-black tracking-[0.35em] uppercase'>
              bioinfometrics market intelligence
            </p>
            <h1 className='text-foreground text-4xl leading-none font-black tracking-tight sm:text-5xl lg:text-6xl xl:text-7xl'>
              Discover Biology&apos;s
              <br />
              <span style={{ color: '#4A7F38' }}>Growth Potential.</span>
            </h1>
            <p className='text-muted-foreground mt-6 max-w-lg text-base leading-relaxed sm:text-lg'>
              Dive into the latest data and insights on the biological sectors.
              Our platform provides unique perspectives on industry trends,
              helping you stay informed and ahead.
            </p>
          </div>

          <div className='flex flex-col gap-4 sm:flex-row'>
            <Link
              href='#pricing'
              onClick={scrollToPricing as any}>
              <Button
                variant='primary'
                className='!px-8 !py-4 !text-[13px]'>
                Subscribe Now
                <ArrowRight className='ml-2 inline-block size-4' />
              </Button>
            </Link>
          </div>
        </div>

        {/* Right Content / Chart Graphic (No motion wrappers) */}
        <div className='w-full md:w-[50%] lg:w-[55%]'>
          <div className='relative mx-auto w-full max-w-xl lg:max-w-2xl'>
            {/* Soft background glow to highlight the chart */}
            <div className='bg-primary/5 absolute -inset-4 z-0 rounded-full blur-3xl' />

            <div className='animate-in fade-in slide-in-from-right-8 relative z-10 w-full duration-700'>
              <Chart />
            </div>
          </div>
        </div>
      </div>

      <div className='mt-auto'>
        <GlowDivider />
      </div>
    </section>
  );
}
